export const symbolList = [
  {
    currency: 'USD',
    symbol: '$',
  },
  {
    currency: 'EUR',
    symbol: '€',
  },
  {
    currency: 'JPY',
    symbol: '¥',
  },
  {
    currency: 'GBP',
    symbol: '£',
  },
  {
    currency: 'AUD',
    symbol: 'A$',
  },
  {
    currency: 'CAD',
    symbol: 'C$',
  },
  {
    currency: 'CHF',
    symbol: 'Fr',
  },
  {
    currency: 'CNY',
    symbol: '¥',
  },
  {
    currency: 'INR',
    symbol: '₹',
  },
  {
    currency: 'BRL',
    symbol: 'B$',
  },
  {
    currency: 'MXN',
    symbol: 'M$',
  },
  {
    currency: 'ZAR',
    symbol: 'R',
  },
  {
    currency: 'NZD',
    symbol: 'NZ$',
  },
  {
    currency: 'SEK',
    symbol: 'kr',
  },
  {
    currency: 'NOK',
    symbol: 'kr',
  },
  {
    currency: 'DKK',
    symbol: 'kr',
  },
  {
    currency: 'SGD',
    symbol: 'S$',
  },
  {
    currency: 'HKD',
    symbol: 'H$',
  },
  {
    currency: 'KRW',
    symbol: '₩',
  },
  {
    currency: 'TRY',
    symbol: '₺',
  },
  {
    currency: 'PLN',
    symbol: 'zł',
  }
];
